module.exports = __webpack_public_path__ + "static/media/18+3.9f7ef2be.png";